import { render, staticRenderFns } from "./RegistrationStatusModal.vue?vue&type=template&id=8e2ed524&scoped=true&lang=pug"
import script from "./RegistrationStatusModal.vue?vue&type=script&lang=js"
export * from "./RegistrationStatusModal.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStatusModal.vue?vue&type=style&index=0&id=8e2ed524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2ed524",
  null
  
)

export default component.exports